import React from 'react'
import PropTypes from 'prop-types'

const ChevronRightIcon = ({ size = 17, color = '#000' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.382 16.626A1.264 1.264 0 014 15.722c0-.339.138-.664.382-.903l6.465-6.327-6.465-6.326a1.264 1.264 0 01-.366-.899c.003-.335.14-.656.382-.893A1.32 1.32 0 015.31 0c.343-.003.673.126.92.359l7.388 7.23c.245.24.382.564.382.903 0 .34-.137.664-.382.904l-7.389 7.23a1.32 1.32 0 01-.923.374 1.32 1.32 0 01-.924-.374z"
        fill={color}
      />
    </svg>
  )
}

ChevronRightIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
}

export default React.memo(ChevronRightIcon)
